import { action } from "../common/Action"
import { ModelliClimaClient } from "../generated";

const service = new ModelliClimaClient();

class MarcheClimaActions {
    @action
    async getAll() {
        return (await service.getMarche())!;
    };
}
export default new MarcheClimaActions();